/**
 * A simple abstraction to make constructing the SLS base path codified and easier to reuse.
 * @param {object} config - Object expects slsStage keys
 * @returns {string} - A string representing the full base path for the current Serverless config.
 * @param {string} service - A string used to denote the service.
 */
// eslint-disable-next-line default-param-last
function getSlsBasePath({ slsStage } = {}, service) {
    return `/${slsStage}${service}`;
}

export default getSlsBasePath;
